const STORAGE_KEY = "initial-password-snooze";
const DEFAULT_DAYS = 7;
const MS_PER_DAY = 24 * 60 * 60 * 1000;

export const SNOOZE_DAY_OPTIONS = [1, 3, 7, 14, 30];

function readMap() {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY));
    if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
      return parsed;
    }
  } catch (e) {
    // ignore broken storage
  }
  return {};
}

function writeMap(map) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
    return true;
  } catch (e) {
    return false;
  }
}

function normalizeKey(value) {
  if (value == null || value === false) return "";
  return String(value).trim();
}

function identityKeys(user) {
  if (!user || typeof user !== "object" || Array.isArray(user)) return [];
  const keys = [];
  [user.openid, user.username, user.id].forEach((value) => {
    const key = normalizeKey(value);
    if (key && keys.indexOf(key) === -1) keys.push(key);
  });
  return keys;
}

function readStoredUser() {
  try {
    const parsed = JSON.parse(localStorage.getItem("user"));
    if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
      return parsed;
    }
  } catch (e) {
    // ignore broken storage
  }
  return null;
}

// 当前登录账号的全部可用身份。组件里的 userinfo 可能还是初始 []，优先用 localStorage。
export function passwordPromptKeys(user) {
  const stored = identityKeys(readStoredUser());
  if (stored.length) return stored;
  return identityKeys(user);
}

export function passwordPromptUserKey(user) {
  const keys = identityKeys(user);
  return keys[0] || "";
}

export function isPasswordPromptSnoozed(userKey) {
  const key = normalizeKey(userKey);
  if (!key) return false;
  const until = Number(readMap()[key]);
  return Number.isFinite(until) && until > Date.now();
}

export function isPasswordPromptSnoozedForUser(user) {
  const keys = passwordPromptKeys(user);
  if (!keys.length) return false;
  return keys.some((key) => isPasswordPromptSnoozed(key));
}

function keysFrom(userOrKey) {
  if (userOrKey && typeof userOrKey === "object") return passwordPromptKeys(userOrKey);
  const key = normalizeKey(userOrKey);
  return key ? [key] : [];
}

export function snoozePasswordPrompt(userOrKey, days) {
  const keys = keysFrom(userOrKey);
  if (!keys.length) return 0;
  const n = parseInt(days, 10);
  const safeDays = SNOOZE_DAY_OPTIONS.indexOf(n) >= 0 ? n : DEFAULT_DAYS;
  const until = Date.now() + safeDays * MS_PER_DAY;
  const map = readMap();
  keys.forEach((key) => {
    map[key] = until;
  });
  if (!writeMap(map)) return 0;
  const stored = readMap();
  const persisted = keys.every((key) => Number(stored[key]) === until);
  if (!persisted) return 0;
  return safeDays;
}

export function clearPasswordPromptSnooze(userOrKey) {
  const keys = keysFrom(userOrKey);
  if (!keys.length) return;
  const map = readMap();
  let changed = false;
  keys.forEach((key) => {
    if (map[key] == null) return;
    delete map[key];
    changed = true;
  });
  if (changed) writeMap(map);
}

// 待办回包决定弹窗开关。进行中的请求若晚于「不提醒」，requestEpoch 已过期，必须保持关闭。
export function nextPasswordPromptVisible(visible, hasPasswordTodo, user, requestEpoch, currentEpoch) {
  const stale = requestEpoch !== currentEpoch;
  const snoozed = isPasswordPromptSnoozedForUser(user);
  if (hasPasswordTodo && !stale && !snoozed) return true;
  if (stale || snoozed) return false;
  return !!visible;
}
